import { IStatus } from "../../../components/StatuLight/StatuLight";
import { IModuleParams } from "../param/paramReducer";

export interface IProgressStepAction {
    type: 'PROGRESS_STEP_UPDATE',
    payload?: IProgressStep[]
}

export interface IProgressStep {
    moduleName: string,
    params: IModuleParams,
    timeStamp: number,
    status: IStatus,
    mid: string,
}

const progressStepDefault: IProgressStep[] = [];

function progressStepReducer(state: IProgressStep[] = progressStepDefault, action: IProgressStepAction): IProgressStep[] {

    switch (action.type as string) {
        case "PROGRESS_STEP_UPDATE":
            return action.payload!;
        case "PROGRESS_CLEAR":
            return progressStepDefault;
        default:
            return state;
    }
}
export default progressStepReducer;